import script from "./TagPeoplePanel.vue?vue&type=script&setup=true&lang=js"
export * from "./TagPeoplePanel.vue?vue&type=script&setup=true&lang=js"

import "./TagPeoplePanel.vue?vue&type=style&index=0&id=9c59c620&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9c59c620"]])

export default __exports__